























































import { Component, Vue } from 'vue-property-decorator'
import { UserInfoProvider, ManagerUserInfoProvider } from '@/provider/userInfo'
import { AuthDynamoDB } from '../provider/dynamodb'
import AWSConfig from '@/assets/aws-exports'

@Component
export default class UserDetail extends Vue {
  userId: string = '';
  username: string = '';
  userData: any = {};
  modules: any = {
    sm: { title: 'セルフモニタリング', page: 'SMWorksheet' },
    cr: { title: '認知再構性', page: 'CRWorksheet' },
    ba: { title: '行動活性化', page: 'BAWorksheet' },
    at: { title: 'アサーション', page: 'ATWorksheet' },
    ps: { title: '問題解決技法', page: 'PSWorksheet' },
    bi: { title: '睡眠行動療法', page: 'BIWorksheet' }
  }
  provider: UserInfoProvider | undefined = undefined;
  menuWorksheetItems: Array<any> = [];

  async beforeMount () {
    console.log(this.$route.params)
    this.userId = this.$route.params.userId
    this.username = this.$route.params.username
    this.provider = new ManagerUserInfoProvider(new AuthDynamoDB(), AWSConfig.userInfoTable)
    console.log(this.username)
    const userInfo = await this.provider.loadByUsername(this.username)
    console.log('userInfo', userInfo)

    const lessonIds = userInfo.data[0] !== undefined ? userInfo.data[0].lesson.map((e: any) => e.lessonId) : []
    const assignedModules = lessonIds.reduce((acc, cur) => {
      cur = cur.replace(/([^\d]*)(\d*)/, (match: string, p1: string) => p1)
      if (this.modules[cur] !== undefined && !acc.find((v: string) => v === cur)) {
        acc.push(cur)
      }
      return acc
    }, [])
    console.log('assignedModules', assignedModules)

    this.menuWorksheetItems = assignedModules.map((e: any) => { return this.modules[e] })
  }
}
